import { render, staticRenderFns } from "./OtherUserRow.vue?vue&type=template&id=577fd720&scoped=true&"
import script from "./OtherUserRow.vue?vue&type=script&lang=js&"
export * from "./OtherUserRow.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserRow.vue?vue&type=style&index=0&id=577fd720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577fd720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
